import { useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import * as Yup from "yup";
import { API_URL } from "../../../../config/apiConfig";

export const CLAIM_STATUS_CONSTATNS = {
  TITLE: "Check your Claim status using your IMEI number.",
  CUSTOMER_NAME: "Customer Name: ",
  IMEI_LABEL: "Enter IMEI",
  SEARCH_CLAIMS_BUTTON: "Search Claims",
  CLAIM_STATUS: "Claim Status: ",
  MODEL: "Model: ",
  STATUS: "Status: ",
  BRAND: "Brand: ",
  CLAIM_NUMBER: "Claim Number: ",
  CONCERNED_PERSON_NAME: "Concerned Person Name: ",
  DEALER: "Dealer: ",
  REJECT_REASON: "Reject Reason: ",
  CLAIM_NOT_FOUND: "Claims Not Found",
  CLAIM_NOT_FOUND_DESC:
    "Sorry, we couldn't find any information for the provided IMEI.",
  ENTER_VALID_IMEI_DESC:
    "Please enter a valid IMEI number to search for details.",
};

export const useClaimStatusData = ({ setIsLoading }) => {
  const [hasSearched, setHasSearched] = useState(false);
  const [searchClaimResult, setSearchClaimResult] = useState(null);

  const claimStatusFormik = useFormik({
    initialValues: { imei: "" },
    validationSchema: Yup.object({
      imei: Yup.string()
        .required("*IMEI is required")
        .matches(/^[0-9]+$/, "Only numbers allowed")
        .length(15, "IMEI must be exactly 15 digits"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setHasSearched(true);
      setSearchClaimResult(null);

      const DATA = {
        serialOrIMEINumber: values?.imei,
      };

      try {
        const res = await axios.post(API_URL.GET_DETAILS_BY_IMEI, DATA);

        const result = res?.data;

        if (res?.status === 200 && result) {
          setSearchClaimResult(result);
          setIsLoading(false);
        } else {
          toast.error(res?.data?.message || "No data found");
          setIsLoading(false);
        }
      } catch (err) {
        if (err?.status === 404) {
          toast.error(err?.response?.data);
          setIsLoading(false);
        } else if (err?.code === "ERR_NETWORK") {
          setIsLoading(false);
        } else {
          toast.error(err?.response?.data);
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    },
  });

  return {
    claimStatusFormik,
    hasSearched,
    searchClaimResult,
    setSearchClaimResult,
    setHasSearched,
  };
};
